import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import { Button, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import ConfModal from '../../../Components/common/ConfModal.js';

export const GeneralSettings = () => {

  const isMounted = useRef(false);
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const [modalConf, setModalConf] = useState(false);
  const [handlerMail, setHandlerMail] = useState(false);
  const [confData, setConfData] = useState({});

  const currencyOptions = [
    { value: "EUR", label: "EUR (€) - Euro", symbol: '€' },
    { value: "USD", label: "USD ($) - US Dollar", symbol: '$' },
    { value: "PHP", label: "PHP (₱) - Philippine Peso", symbol: '₱' },
    { value: "JPY", label: "JPY (¥) - Japanese Yen", symbol: '¥' },
    { value: "GBP", label: "GBP (£) - British Pound", symbol: '£' },
    { value: "AUD", label: "AUD (A$) - Australian Dollar", symbol: 'A$' },
    { value: "CHF", label: "CHF (Fr.) - Swiss Franc", symbol: 'Fr.' },
    { value: "CAD", label: "CAD (C$) - Canadian Dollar", symbol: 'C$' },
    { value: "MXN", label: "MXN ($) - Mexican Peso", symbol: '$' },
    { value: "CNY", label: "CNY (¥) - Chinese Yuan", symbol: '¥' },
    { value: "NZD", label: "NZD (NZ$) - New Zealand Dollar", symbol: 'NZ$' },
    { value: "SEK", label: "SEK (kr) - Swedish Krona", symbol: 'kr' },
    { value: "RUB", label: "RUB (₽) - Russian Ruble", symbol: '₽' },
    { value: "HKD", label: "HKD (HK$) - Hong Kong Dollar", symbol: 'HK$' },
    { value: "NOK", label: "NOK (kr) - Norwegian Krone", symbol: 'kr ' },
    { value: "SGD", label: "SGD (S$) - Singapore Dollar", symbol: 'S$' },
    { value: "TRY", label: "TRY (₺) - Turkish Lira", symbol: '₺' },
    { value: "KRW", label: "KRW (₩) - South Korean Won", symbol: '₩' },
    { value: "ZAR", label: "ZAR (R) - South African Rand", symbol: 'R' },
    { value: "BRL", label: "BRL (R$) - Brazilian Real", symbol: 'R$' },
    { value: "INR", label: "INR (₹) - Indian Rupee", symbol: '₹' },
    { value: "SAR", label: "SAR (﷼) - Saudi Riyal", symbol: '﷼' },
    { value: "DKK", label: "DKK (kr) - Danish Krone", symbol: 'kr' },
    { value: "RON", label: "RON (lei) - Romanian Leu", symbol: 'lei' },
    { value: "XAF", label: "XAF (Fr) - Central African CFA Franc", symbol: 'Fr' },
    { value: "XOF", label: "XOF (Fr) - West African CFA Franc", symbol: 'Fr' },
    { value: "DOP", label: "DOP (RD$) - Dominican Peso", symbol: 'RD$)' },
    { value: "HTG", label: "HTG (G) - Haitian Gourde", symbol: 'G' },
    { value: "BBD", label: "BBD (Bds$) - Barbadian Dollar", symbol: 'Bds$' },
    { value: "TTD", label: "TTD (TT$) - Trinidad and Tobago Dollar", symbol: 'TT$)' },
    { value: "XCD", label: "XCD (EC$) - East Caribbean Dollar", symbol: 'EC$' },
    { value: "ANG", label: "ANG (ƒ) - Netherlands Antillean Guilder", symbol: 'ƒ' },
    { value: "COP", label: "COP (COL$) - Colombian Peso", symbol: 'COL$' },
    { value: "XDR", label: "XDR (SDR) - IMF Special Drawing Rights", symbol: 'SDR' },
    { value: "XBT", label: "XBT (₿) - Bitcoin", symbol: '₿' },
    { value: "WGH", label: "WGH - West German Hard Currency", symbol: 'WGH' },
  ];

  const fetchSettings = async () => {
    try {
      const res = await withRFSToken.get('general-setting/get-setting');
      const innerData = res?.data?.response_data?.settings;
      console.log("innerData", innerData)
      setSelectedCurrency(innerData?.currency || 'EUR')
      setHandlerMail(innerData?.handler_email == 1 ? true : false  || false)
    } catch (error) {
      console.error('Error fetching settings:', error);
      toast.error('Failed to load settings');
    }
  };

  useEffect(() => {
    if (isMounted.current) return;
    fetchSettings()
    isMounted.current = true;
  }, []);
  const handleCurrencyChange = async (event) => {
    const { name, value } = event.target;
    // const numericValue = value.replace(/\D/g, "");
    // setSelectedCurrency(value)

    try {
      const res = await withRFSToken.post('general-setting/save-setting', { settings: { currency: value } });
      if (res.data.response_code === 200) {
        const innerData = res.data.response_data;
        // setSelectedCurrency(innerData);
        fetchSettings();
      };

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const switchChange = (e) => {
    const isChecked = e.target.checked;
    // console.log("🚀 ~ switchChange ~ isChecked:", isChecked)
    // setSwitchData(isChecked);
    // const modalData = isChecked ? 'Y' : 'N';
    // setModalFor(isChecked)
    setConfData({
      header: `${isChecked ? 'Active' : 'De-Active'}  atomatic mail sending`,
      subHeader: `If you confirm this, Automatically email sending will be ${isChecked ? 'Activated' : 'Deactivated'}`,
      modalConf: () => tabChangeConf(isChecked),
      closeModal: confModalClose,
      primaryBtn: 'Yes',
      secondaryBtn: 'No',
    })
    setModalConf(true);
  }

  const confModalClose = () => {
    setModalConf(false);
  }
  const tabChangeConf = async(mode) => {
    //  console.log("🚀 ~ switchChange ~ mode:", mode)
    try {
      const res = await withRFSToken.post('general-setting/save-setting', { settings: { handler_email: mode } });
      if (res.data.response_code === 200) {
        const innerData = res.data.response_data;
        // setSelectedCurrency(innerData);
        fetchSettings();
      };

    } catch (error) {
      console.error('Error fetching data:', error);
    }
    // setHandlerMail(mode);
  }

  const SBack = localStorage.getItem('SettingsBack');

  return (
    <>
      {/* {console.log("🚀 ~ switchChange ~ handlerMail:", handlerMail)} */}
      {modalConf &&
        <ConfModal
          header={confData.header}
          subHeader={confData.subHeader}
          modalConf={confData.modalConf}
          closeModal={confData.closeModal}
          primaryBtn={confData.primaryBtn}
          secondaryBtn={confData.secondaryBtn}
        />
      }
      {/* <div className="">
        <Header logo_url={SBack ? SBack : '/ServiceRecovery'} sBackUrl={SBack ? SBack : '/ServiceRecovery'} />
        <div className="page-body-wrapper schedule">
          <LeftMenu />
          <div className="main-panel">
            <div className="row">

              <LeftSettings /> */}
              <div className='col-9 col-xxl-9 stting_right'>
                <div className='settingbg_right'>
                  <h4>General Settings</h4>
                  <p>Set your notification preferences for when you are in or away from the dashboard.</p>
                  <hr />
                  <div className='d-flex align-items-center'>
                    <div className='me-3'>
                      <h4>Default Currency</h4>
                      <p className='mb-0'>Set default currency</p>
                    </div>
                    <div className='d-flex align-items-center st_days'>
                      <Form.Select size="sm" className="euro_amount_select" value={selectedCurrency} onChange={handleCurrencyChange}>
                        {currencyOptions.map(opt => (
                          <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                      </Form.Select>
                    </div>
                  </div>

                  <hr />
                  <div className='d-flex align-items-center'>
                    <div className='me-3'>
                      <h4>Automatic Email Sending</h4>
                      <p className='mb-0'>Enable this to allow the system to send email to handlers</p>
                    </div>
                    <div className='d-flex align-items-center st_days'>
                      {/* <Form.Check // prettier-ignore
                                            type="switch"
                                            id="custom-switch"
                                            label="Activate Button"
                                            onChange={switchChange}
                                            checked={switchData}
                                          /> */}
                      <div className="new_tgl me-3">
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={handlerMail}
                            onChange={switchChange}
                            id={`custom-switch`}
                          />
                          <span className="slider-text">
                            <span className="off">
                              No <span className="circle"></span>
                            </span>
                            <span className="on">
                              Yes <span className="checkmark">✓</span>
                            </span>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            {/* </div>
          </div>
        </div>
      </div> */}
    </>
  )
}

export default GeneralSettings;